<div class="container">
  <div class="wrapper">
    <div class="margin-bot-40" *ngIf="showMessage">
      <app-download-message [state]="state" (exit)="closeMessage()" [title]="title">
      </app-download-message>
    </div>

    <div style="max-width: 518px; margin: 0 20px 20px 0">
      <div class="title-section">
        <div style="display: flex; justify-content: center">
          <ion-icon class="item-icono" name="checkmark-circle-sharp"></ion-icon>
        </div>
        <h1 class="title">Recibimos tu Solicitud de Pensión por Vejez</h1>
      </div>

      <div>
        <h2 class="sub-title mt-40">¿Qué viene ahora?</h2>
        <ion-text class="div-text">
          Nos contactaremos contigo por correo dentro de 10 días para informar sobre el resultado de tu solicitud,
          próximos pasos e información relevante del trámite de Pensión por Vejez.
        </ion-text>
      </div>

      <div class="importante-PGU mt-40">
        <div class="icon-container importante-PGU-icon">
          <ion-icon class="i-info-fill-2" aria-hidden="true"></ion-icon>
        </div>
        <div>
          <p class="importante-PGU-title">Importante: Pensión Garantizada Universal (PGU)</p>
          <p class="importante-PGU-description">
            Si seleccionaste que solicitarás PGU, debes realizar el trámite directamente en el sitio web de
            <a href="https://mi.chileatiende.gob.cl/tramites/sibs" target="_blank">ChileAtiende</a>
            <ion-icon name="open-outline" class="external-link-icon" aria-hidden="true"></ion-icon>
          </p>
        </div>
      </div>

      <div class="mt-40">
        <h2 class="sub-title">Este es tu comprobante</h2>
        <ion-text class="div-text">
          También lo enviamos a tu correo
          <span style="font-weight: 600">{{ applicationData.email }} </span>
          . En caso de no encontrarlo en tu bandeja principal, por favor, revisa tu spam.
        </ion-text>

        <!-- Datos de solicitud -->
        <div class="div-personal-data mt-40">

          <!-- Fila 1 -->
          <div class="div-data">
            <ion-text class="descripcion">N° de solicitud:</ion-text>
            <ion-text class="value" [class.sinRegistro]="!applicationData.RequestNumber">
              {{ applicationData.RequestNumber || "********" }}
            </ion-text>
          </div>

          <div class="div-data">
            <ion-text class="descripcion">Fecha de solicitud:</ion-text>
            <ion-text class="value" [class.sinRegistro]="!applicationData.longDate">
              {{ applicationData.longDate || "********" }}
            </ion-text>
          </div>

          <!-- Divider -->
          <div class="divider"></div>

          <!-- Fila 2 -->
          <div class="div-data">
            <ion-text class="descripcion">Tipo de trámite:</ion-text>
            <ion-text class="value" [class.sinRegistro]="!applicationData.typeApplication">
              {{ applicationData.typeApplication || "********" }}
            </ion-text>
          </div>

        </div>
      </div>

      <div class="importante-ayuda mt-40">
        <p class="sub-title">¿Necesita ayuda?</p>
        <ion-text class="div-text">
          Llámanos al <a href="tel:+6006600900">600 6600 900</a> o escríbenos por WhatsApp al <a
            href="https://wa.me/56936391222" target="_blank">+569 3639 1222</a> o agenda una <button type="button"
            class="link" (click)="goToVideoAtencion()">
            Video Atención
          </button>
        </ion-text>
      </div>

      <div class="centrar mt-40">
        <button class="control-btn primary-button" [disabled]="isLoadingPdf" (click)="downloadVoucher()">Descargar
          comprobante</button>
      </div>
      <div class="centrar mt-24">
        <button class="control-btn secondary-button" (click)="goToHome()">Ir a Inicio</button>
      </div>
    </div>
  </div>
</div>